import { isType } from '../utils/'

export default (absence: any): boolean => {
  return absence instanceof RegExp
    ? absence.test(window.location.href.replace(window.location.origin, ''))
    : (isType(absence, 'Function') ? absence() : undefined)
}
